/*
  <H2 
    color={color} 
    size={size} 
    className={className}
  />
  - - - - - - - - - - - - -
  color -> white / black
  size -> xl / lg / md / sm / xs
  className -> css classes
  - - - - - - - - - - - - -
*/

export default function H2({
  color,
  className,
  desktopSize,
  mobileSize,
  children,
  ...props
}) {
  return (
    <h2
      className={`title tc-${color} title--${desktopSize}-d title--${mobileSize} ${className}`}
      {...props}
    >
      {children}
    </h2>
  );
}

H2.defaultProps = {
  color: "black",
  desktopSize: "lg",
  mobileSize: "sm",
  className: "",
};
